import _regeneratorRuntime from "/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import verify from '../flattened/verify.js';
import { JWSInvalid } from '../../util/errors.js';
import { decoder } from '../../lib/buffer_utils.js';

function compactVerify(_x, _x2, _x3) {
  return _compactVerify.apply(this, arguments);
}

function _compactVerify() {
  _compactVerify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(jws, key, options) {
    var _jws$split, protectedHeader, payload, signature, length, verified, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (jws instanceof Uint8Array) {
              jws = decoder.decode(jws);
            }

            if (!(typeof jws !== 'string')) {
              _context.next = 3;
              break;
            }

            throw new JWSInvalid('Compact JWS must be a string or Uint8Array');

          case 3:
            _jws$split = jws.split('.'), protectedHeader = _jws$split[0], payload = _jws$split[1], signature = _jws$split[2], length = _jws$split.length;

            if (!(length !== 3)) {
              _context.next = 6;
              break;
            }

            throw new JWSInvalid('Invalid Compact JWS');

          case 6:
            _context.next = 8;
            return verify({
              payload: payload || undefined,
              protected: protectedHeader || undefined,
              signature: signature || undefined
            }, key, options);

          case 8:
            verified = _context.sent;
            result = {
              payload: verified.payload,
              protectedHeader: verified.protectedHeader
            };

            if (!(typeof key === 'function')) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", _objectSpread({}, result, {
              key: verified.key
            }));

          case 12:
            return _context.abrupt("return", result);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _compactVerify.apply(this, arguments);
}

export { compactVerify };
export default compactVerify;